<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import dict from "@/common/js/dict";
import axios from "axios";
import {rootUrl} from "@/config";
import {debounce} from "throttle-debounce";
import util from "@/common/js/util";
import constants from "@/common/constants";
import {router} from "@/router";

export default {
  name: 'app',
  components: {},

  mounted() {
    setTimeout(() => {
      this.loadCompany();
    }, 3000);

  },
  methods: {
    async loadCompany() {
      var resCondition = await axios.get(rootUrl + 'public/queryCompanyByCondition?zx=1',{loading:false})
      if (resCondition.data.module) {
        var data = resCondition.data.module;
        // this.selectByFileId(data.backgroundImageOfClientLoginPage);
        let clientCompanyInfo = {
          companyId: data.id,
          englishName: data.englishName,
          clientCompanyName: data.clientCompanyName,
          clientCompanyLogo: data.clientCompanyLogo,
          backgroundImageOfClientLoginPage: data.backgroundImageOfClientLoginPage,
          keyContactPhone: data.keyContactPhone,
          firstPageBackGroundImg:data.firstPageBackGroundImg,
          firstPageActiveImg:data.firstPageActiveImg,
          serviceModule: data.bizMenuModule,
          recordCompanyName:data.recordCompanyName,
          recordNo:data.recordNo,
          registerAtMiit:data.registerAtMiit,
          recordAddress:data.recordAddress,
          domainType:data.domainType //1物流 ，3专线
        };
        //查询图片
        // if (!clientCompanyInfo.clientCompanyLogo){
        //   let module = await this.axiosJSON.post('public/file/query', {groupId: data.clientCompanyLogo})
        //   clientCompanyInfo.clientCompanyLogo = module.module ? module.module[0].fileUrl : '';
        // }
        // if (!clientCompanyInfo.backgroundImageOfClientLoginPage.length){
        //   let module = await this.axiosJSON.post('public/file/query', {groupId: data.backgroundImageOfClientLoginPage})
        //   clientCompanyInfo.backgroundImageOfClientLoginPage = module.module ? module.module[0].fileUrl : '';
        // }
        window.localStorage.setItem("clientCompanyInfo", JSON.stringify(clientCompanyInfo));
        window.dispatchEvent(new CustomEvent("companyStorage", {detail: {clientCompanyInfo}}));
        window.$onload();
        console.log('clientCompanyInfo.serviceModule',clientCompanyInfo.serviceModule)
        if(clientCompanyInfo.serviceModule && clientCompanyInfo.serviceModule.length > 0){
          //  尾程也有询价 去掉这里
           // if(!clientCompanyInfo.serviceModule.includes('1') && !clientCompanyInfo.serviceModule.includes('3') ){
           //    //地址包含token 就不能跳转了
           //   console.log('window.location.host',window.location.host)
           //    if(window.location.href.indexOf('token')<0){
           //      //尾程默认到跳转到登陆
           //      this.$router.push({path: "/login"});
           //    }
           // }
        }


      }
    },

    //查询
    selectByFileId(id) {
      this.axios({
        url: "public/file/query",
        method: "post",
        data: {
          groupId: id,
        },
      }).then(r => {
        if (r.success && r.module) {
          r.module;
        }
      })
    },
  }
}
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
  /*background: url(assets/bg1.jpg) center !important;
    background-size: cover;*/
  // background: #1F2D3D;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

#app {
  position: fixed;
  top: 0px;
  bottom: 0px;
  width: 100%;
}

td.el-table__cell {
  font-size: 12px;
}

.el-submenu [class^=fa] {
  vertical-align: baseline;
  margin-right: 10px;
}

.el-menu-item [class^=fa] {
  vertical-align: baseline;
  margin-right: 10px;
}

.toolbar {
  background: #f2f2f2;
  padding: 10px;
  //border:1px solid #dfe6ec;
  margin: 10px 0px;

  .el-form-item {
    margin-bottom: 10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue